(function(){
'use strict';

scSupporterDonationsCtrl.$inject = ["$log", "$scope", "$timeout", "$state", "scFundraisingPagesService", "scFundraisingTeamsService", "scMembersService", "scOrganizationsService", "scFlowModalService", "scBanner", "DonationsCollection", "$window"];
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Controller for listing donations of a team or page in the
 * fundraising dashboard. Allows for acknowledgements donations
 * and allocating funds if it is a team.
 * @kind Controller
 */

function scSupporterDonationsCtrl($log, $scope, $timeout, $state, scFundraisingPagesService, scFundraisingTeamsService, scMembersService, scOrganizationsService, scFlowModalService, scBanner, DonationsCollection, $window) {
  // Constants and configuration

  var LOAD_ALL_LIMIT = 100;
  var SEARCH_DEBOUNCE_MS = 300;

  var hideAlreadyDonatedTooltip = 'Hide people who have donated to your current fundraiser';
  var showAlreadyDonatedTooltip = 'Show people who have already donated to your current fundraiser';

  // Utility functions

  var safeGet = function safeGet(obj, path) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return _.get(obj, path, defaultValue);
  };

  function showModal(title, message, iconClass) {
    if (!scFlowModalService || !scFlowModalService.open) return;

    $scope.modalTitle = title;
    $scope.modalMessage = message;
    $scope.modalIconClass = iconClass;
    scFlowModalService.open({
      templateUrl: 'frs/shared/supporter/pages/donations/modals/pastDonors',
      maxWidth: 500,
      context: $scope
    });
  }

  function formatCsvCell(cell) {
    var s = cell == null ? '' : String(cell);
    var needsQuotes = s.includes(',') || s.includes('"') || s.includes('\n');
    var escaped = s.replace(/"/g, '""');
    return needsQuotes ? '"' + escaped + '"' : escaped;
  }

  function setLoadingState(loading) {
    var filtering = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    $scope.loading = loading;
    $scope.filtering = filtering;
  }

  // Model initialization

  var model = void 0;
  if ($state.includes('frs.team')) {
    model = safeGet(scFundraisingTeamsService.active, 'current', null);
  } else {
    model = safeGet(scFundraisingPagesService.active, 'current', null);
  }

  if (!model) {
    $log.warn('Fundraiser Dashboard Donation Controller: Neither a team nor a page is defined.');
  }

  // Scope Properties

  $scope.notification = {};
  $scope.isTeam = !!$state.includes('frs.team');
  $scope.donations = [];
  $scope.allPastDonors = [];
  $scope.allocation = {};
  $scope.me = scMembersService.active.current;
  $scope.sort = 'desc';
  $scope.timeframe = 'current';
  $scope.displayLoadMore = false;
  $scope.filtering = false;
  $scope.loading = false;
  $scope.orgName = scOrganizationsService.active.current.name;
  $scope.showVerification = false;
  $scope.hasPastDonors = null;
  $scope.hideAlreadyDonated = false;
  $scope.searchUpdates = { filter: '' };
  $scope.pastNameSortReverse = false;
  $scope.hideAlreadyDonatedTooltip = hideAlreadyDonatedTooltip;
  $scope.pastDonorsPagination = {
    currentPage: 1,
    totalPages: 1,
    perPage: 5,
    totalItems: 0
  };

  // Scope Methods

  $scope.loadMoreDonations = loadMoreDonations;
  $scope.resort = resort;
  $scope.getMemberFirstInitial = scMembersService.getMemberFirstInitial;
  $scope.goToPage = goToPage;
  $scope.changeRowsPerPage = changeRowsPerPage;
  $scope.getPageOptions = getPageOptions;
  $scope.getPaginationRange = getPaginationRange;
  $scope.hasPrevPage = hasPrevPage;
  $scope.hasNextPage = hasNextPage;
  $scope.togglePastNameSort = togglePastNameSort;
  $scope.selectDonors = selectDonors;
  $scope.toggleHideAlreadyDonated = toggleHideAlreadyDonated;
  $scope.copyAllEmails = copyAllEmails;
  $scope.exportAll = exportAll;
  $scope.donateLink = getDonateLink;
  $scope.donorFilter = filterDonors;

  // Initialization

  var donationsCollection = new DonationsCollection(model, $scope.me, $scope.isTeam);

  donationsCollection.getPastDonors(1).then(function (_ref) {
    var data = _ref.data;

    var batch = safeGet(data, 'data', []);
    $scope.hasPastDonors = batch.length > 0;
  }).catch(function () {
    $scope.hasPastDonors = false;
  });

  loadMoreDonations();

  if ($scope.isTeam) {
    $scope.allocation.amount = model.net_credit_balance;
  }

  $scope.$on('sc-donor-thanked', function (_, args) {
    $scope.notification = args.notification;
    $scope.showVerification = true;
    $timeout(function () {
      $scope.showVerification = false;
    }, 3000);
  });

  var searchTimeout = void 0;
  $scope.$watch('searchUpdates.filter', function (newVal, oldVal) {
    if (newVal !== oldVal && $scope.timeframe === 'past') {
      if (searchTimeout) {
        $timeout.cancel(searchTimeout);
      }
      searchTimeout = $timeout(function () {
        applyPastDonorFilters();
      }, SEARCH_DEBOUNCE_MS);
    }
  });

  $scope.$watch('hideAlreadyDonated', function (newVal) {
    $scope.hideAlreadyDonatedTooltip = newVal ? showAlreadyDonatedTooltip : hideAlreadyDonatedTooltip;
  });

  function loadMoreDonations() {
    $scope.displayLoadMore = false;

    setLoadingState(true, true);

    if ($scope.timeframe === 'past') {
      loadPastDonors();
    } else {
      loadCurrentDonors();
    }
  }

  function loadPastDonors() {
    donationsCollection.resetPastPage();
    donationsCollection.getPastDonors(LOAD_ALL_LIMIT, {
      sortReverse: $scope.pastNameSortReverse
    }).then(function (_ref2) {
      var data = _ref2.data;

      var batch = safeGet(data, 'data', []);
      $scope.allPastDonors = batch;

      if ($scope.hasPastDonors === null) {
        $scope.hasPastDonors = batch.length > 0;
      }

      applyPastDonorFilters();
    }).catch(function () {
      $scope.hasPastDonors = false;
    }).finally(function () {
      setLoadingState(false);
    });
  }

  function loadCurrentDonors() {
    donationsCollection.get($scope.sort).then(function (donations) {
      var batch = safeGet(donations, 'data.data', []);
      $scope.donations = [].concat(_toConsumableArray($scope.donations), _toConsumableArray(batch));
      $scope.displayLoadMore = batch.length === 10;
    }).catch(function (error) {
      $log.error('Failed to load current donors:', error);
      scBanner('Failed to load donations', 'error');
    }).finally(function () {
      setLoadingState(false);
    });
  }

  function applyPastDonorFilters() {
    // Early return if no data
    if (!$scope.allPastDonors || $scope.allPastDonors.length === 0) {
      $scope.donations = [];
      $scope.pastDonorsPagination.totalItems = 0;
      $scope.pastDonorsPagination.totalPages = 1;
      return;
    }

    var filtered = $scope.allPastDonors;

    if ($scope.hideAlreadyDonated) {
      filtered = filtered.filter(function (d) {
        var donatedToCurrent = safeGet(d, 'donated_to_current');
        return !donatedToCurrent || donatedToCurrent !== true && donatedToCurrent !== 1 && donatedToCurrent !== '1';
      });
    }

    var searchTerm = $scope.searchUpdates.filter;
    if (searchTerm && searchTerm.trim()) {
      var term = searchTerm.toLowerCase().trim();
      filtered = filtered.filter(function (donation) {
        var name = safeGet(donation, '_pastDonorName', '').toLowerCase();
        return name.includes(term);
      });
    }

    // Validate and set pagination
    var originalPerPage = $scope.pastDonorsPagination.perPage;
    var currentPage = parseInt($scope.pastDonorsPagination.currentPage, 10) || 1;
    var perPage = isNaN(originalPerPage) || originalPerPage < 1 ? 5 : parseInt(originalPerPage, 10);
    var maxPages = Math.ceil(filtered.length / perPage) || 1;

    // Update pagination state
    $scope.pastDonorsPagination.totalItems = filtered.length;
    $scope.pastDonorsPagination.totalPages = maxPages;
    $scope.pastDonorsPagination.perPage = perPage;
    $scope.pastDonorsPagination.currentPage = currentPage > maxPages ? 1 : currentPage;

    // Calculate and display current page
    var startIndex = ($scope.pastDonorsPagination.currentPage - 1) * perPage;
    $scope.donations = filtered.slice(startIndex, startIndex + perPage);
  }

  function filterDonors(donation) {
    if (!$scope.searchUpdates.filter || !$scope.searchUpdates.filter.trim()) {
      return true;
    }
    var searchTerm = $scope.searchUpdates.filter.toLowerCase().trim();
    var memberName = safeGet(donation, 'member_name', '');
    return memberName && memberName.toLowerCase().includes(searchTerm);
  }

  function goToPage(pageNum) {
    var parsedPageNum = parseInt(pageNum, 10);
    if (parsedPageNum < 1 || parsedPageNum > $scope.pastDonorsPagination.totalPages) return;
    if ($scope.loading) return;

    $scope.pastDonorsPagination.currentPage = parsedPageNum;

    if ($scope.timeframe === 'past') {
      applyPastDonorFilters();
    } else {
      setLoadingState(true, true);
      donationsCollection.resetPage();
      donationsCollection.page = parsedPageNum - 1;

      donationsCollection.get($scope.sort).then(function (donations) {
        var batch = safeGet(donations, 'data.data', []);
        $scope.donations = batch;
      }).catch(function (error) {
        $log.error('Failed to load current donors:', error);
        scBanner('Failed to load donations', 'error');
      }).finally(function () {
        setLoadingState(false);
      });
    }
  }

  function changeRowsPerPage(newPerPage) {
    $scope.pastDonorsPagination.perPage = parseInt(newPerPage, 10);
    $scope.pastDonorsPagination.currentPage = 1;

    if ($scope.timeframe === 'past') {
      applyPastDonorFilters();
    } else {
      donationsCollection.resetPage();
      setLoadingState(true, true);
      loadCurrentDonors();
    }
  }

  function getPageOptions() {
    var options = [];
    for (var i = 1; i <= $scope.pastDonorsPagination.totalPages; i += 1) {
      options.push(i);
    }
    return options;
  }

  function getPaginationRange() {
    var currentPage = $scope.pastDonorsPagination.currentPage;
    var perPage = $scope.pastDonorsPagination.perPage;
    var totalItems = $scope.pastDonorsPagination.totalItems;

    var start = (currentPage - 1) * perPage + 1;
    var end = Math.min(currentPage * perPage, totalItems);

    return { start: start, end: end };
  }

  function hasPrevPage() {
    return $scope.pastDonorsPagination.currentPage > 1;
  }

  function hasNextPage() {
    return $scope.pastDonorsPagination.currentPage < $scope.pastDonorsPagination.totalPages;
  }

  function selectDonors(tab) {
    if ($scope.timeframe === tab) {
      return;
    }
    $scope.timeframe = tab;
    $scope.donations = [];

    if (tab === 'past') {
      donationsCollection.resetPastPage();
      $scope.pastDonorsPagination.currentPage = 1;
    } else {
      donationsCollection.resetPage();
    }
    loadMoreDonations();
  }

  function toggleHideAlreadyDonated() {
    if ($scope.timeframe !== 'past') return;

    $scope.hideAlreadyDonated = !$scope.hideAlreadyDonated;
    $scope.pastDonorsPagination.currentPage = 1;
    applyPastDonorFilters();
  }

  function togglePastNameSort() {
    $scope.pastNameSortReverse = !$scope.pastNameSortReverse;
    $scope.pastDonorsPagination.currentPage = 1;

    loadPastDonors();
  }

  function resort() {
    if ($scope.filtering) return;
    $scope.sort = $scope.sort === 'asc' ? 'desc' : 'asc';
    $scope.donations = [];
    donationsCollection.resetPage();
    $scope.filtering = true;
    loadMoreDonations();
  }

  function copyAllEmails() {
    var uniqueEmails = new Set();

    $scope.donations.forEach(function (donation) {
      var email = safeGet(donation, 'email_address');
      if (email && email.trim()) {
        uniqueEmails.add(email.trim());
      }
    });

    var payload = Array.from(uniqueEmails).join(', ');

    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(payload).then(function () {
        showModal('All donor emails copied', 'Now paste them into your personal email', 'fa fa-envelope-o');
      }).catch(function () {
        scBanner('Failed to copy emails to clipboard', 'error');
      });
    }
  }

  function exportAll() {
    var donations = $scope.donations || [];
    if (!donations.length) {
      scBanner('No donations to export', 'warning');
      return;
    }

    var rows = new Array(donations.length + 1);
    rows[0] = ['Name', 'Already donated', 'Fundraiser name', 'Amount', 'Email'];

    donations.forEach(function (d, index) {
      rows[index + 1] = [safeGet(d, '_pastDonorName'), safeGet(d, 'donated_to_current') ? 'Yes' : 'No', safeGet(d, 'title'), '$' + safeGet(d, 'amount'), safeGet(d, 'email_address')];
    });

    var csv = rows.map(function (row) {
      return row.map(formatCsvCell).join(',');
    }).join('\n');

    var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    var url = ($window.URL || $window.webkitURL).createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = $scope.orgName + ' past donors.csv';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();

    // Clean up immediately
    $timeout(function () {
      document.body.removeChild(a);
      ($window.URL || $window.webkitURL).revokeObjectURL(url);
    }, 100);

    showModal('Successfully exported donor information', 'The CSV file is now in your downloads folder.', 'fa fa-download');
  }

  function getDonateLink() {
    if ($state.current.name.indexOf('fundraiser') > -1) {
      return '/give/f' + scFundraisingPagesService.active.current.id + '/#!/donation/checkout';
    }
    return '/give/t' + scFundraisingTeamsService.active.current.id + '/#!/donation/checkout';
  }
}

angular.module('classy.frs').controller('scSupporterDonationsCtrl', scSupporterDonationsCtrl);
})();